// extracted by mini-css-extract-plugin
export default {"no-results-icon":"gkr9BfHL9lVFcSXU8q39","noResultsIcon":"gkr9BfHL9lVFcSXU8q39"};